import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateServiceService {

 formatDate(date:number){
   let d = new Date(date)
   let theyear = d.getFullYear();
   let themonth = d.getMonth() + 1;
   let thetoday = d.getDate();

  return theyear + "/" + themonth + "/" + thetoday
 }
}
